import { FormProvider, type UseFormReturn } from 'react-hook-form';
import SelectTestsStepHeader from './Components/StepHeader/SelectTestsStepHeader';
import EstimatedTime from './Components/StepperNavigationButtons/Components/EstimatedTime';
import NextButtonComponent from './Components/StepperNavigationButtons/Components/NextButtonComponent';
import { SelectTestsStepperNavigationButtons } from './Components/StepperNavigationButtons/SelectTestsStepperNavigationButtons';
import TestsPanel from './Components/TestsPanel/TestsPanel';
import type { SelectTestsFormValues } from './SelectTestsStep.schema';
import ProcessingState from '@/Models/ProcessingState';

export interface SelectTestsStepFormProps {
    form: UseFormReturn<SelectTestsFormValues>;
    processingState: ProcessingState;
    activeStep: number;
    handleBack?: () => void;
    onSubmit: (values: SelectTestsFormValues) => void | Promise<void>;
    onInvalid: () => void;
    onBackPersistTestLanguage: (testLanguage: string) => void;
}

const SelectTestsStepForm = ({
    form,
    processingState,
    activeStep,
    handleBack,
    onSubmit,
    onInvalid,
    onBackPersistTestLanguage,
}: SelectTestsStepFormProps) => {
    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit, onInvalid)}>
                <SelectTestsStepHeader />
                <TestsPanel />
                <SelectTestsStepperNavigationButtons
                    activeStep={activeStep}
                    handleBack={handleBack}
                    onBackPersistTestLanguage={onBackPersistTestLanguage}
                    nextButtonComponent={<NextButtonComponent processingState={processingState} />}
                    centeredComponent={<EstimatedTime />}
                />
            </form>
        </FormProvider>
    );
};

export default SelectTestsStepForm;
